<template>
    <div>
        <n-bread
                v-bind:content="{bread_list, bread_active}"
        ></n-bread>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-xs-12 col-sm-6" v-for="item in newsList">


                <div class="card abtg__default-card abtg__default-card-border">
                    <div class="card-head">

                        <header v-html="item.date"></header>

                        <div class="tools">

                        </div>
                    </div>


                    <div class="card-body ">
                        <p class="space-after-p  abtg-title"><strong>{{item.title}}</strong>
                            <br>
                            <span class="abtg-category">in {{item.category}}</span>
                        </p>
                        <a target="_blank" v-bind:href="item.permaLinkApp"
                           class="btn  btn-default abtg__btn-star btn-block">
                            Leggi
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NBread from '@/partials/bread';
    import {mapActions, mapState, mapMutations} from 'vuex';
    export default{
        components: {
            NBread,
        },
        computed: {
            ...mapState('n_feed', [
                'bread_active', 'bread_list', 'newsList'
            ]),
        },
        created(){
            this.SET_DATA({name: 'bread_active', data: {label: 'Le news ABTG sul Mercato Immobiliare'}});
            this.getNewsList();
        },

        methods: {
            ...mapActions('n_feed', ['getNewsList']),
            ...mapMutations('n_feed', ['SET_DATA']),
        }
    }
</script>